"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mappingDocumentSchema = void 0;
exports.parseMappingDocument = parseMappingDocument;
// `config/mappings/<file>.yaml` (SPEC §3.2): how a loader reads one source file, so the registry's column
// headers can change without code. `columns` maps each canonical field to its source header; `value_maps`
// translate a mapped field's source values (e.g. `"Performance Met": MET`). Which canonical fields a file
// needs is the loader's rule (SPEC §3.2 "Canonical fields required per file"), not this document's.
const zod_1 = require("zod");
const config_issue_js_1 = require("./config-issue.js");
const FILE_TYPES = ["csv", "xlsx"];
const XLSX = "xlsx";
// strftime-style date directives the loaders read (SPEC §3.2 `"%m/%d/%Y"`); anything else is a literal.
const DATE_FORMAT = /^(?:[^%]|%[Yymd])+$/;
const canonicalNameSchema = zod_1.z
    .string()
    .regex(/^[a-z][a-z0-9_]*$/, "canonical field names are lower snake_case");
exports.mappingDocumentSchema = zod_1.z
    .strictObject({
    file_type: zod_1.z.enum(FILE_TYPES),
    sheet: zod_1.z.string().min(1).nullable().default(null),
    header_row: zod_1.z.int().min(1).default(1),
    columns: zod_1.z
        .record(canonicalNameSchema, zod_1.z.string().min(1, "source header must not be empty"))
        .refine((columns) => Object.keys(columns).length > 0, "columns maps at least one field"),
    value_maps: zod_1.z.record(canonicalNameSchema, zod_1.z.record(zod_1.z.string(), zod_1.z.string().min(1))).default({}),
    date_format: zod_1.z
        .string()
        .regex(DATE_FORMAT, "date_format uses only %Y, %y, %m, %d and literal characters"),
})
    .superRefine((mapping, ctx) => {
    if (mapping.sheet !== null && mapping.file_type !== XLSX) {
        ctx.addIssue({
            code: "custom",
            path: ["sheet"],
            message: "sheet applies only to xlsx files",
        });
    }
    for (const field of Object.keys(mapping.value_maps)) {
        if (Object.hasOwn(mapping.columns, field))
            continue;
        const message = `value map for ${field}, which columns does not map`;
        ctx.addIssue({ code: "custom", path: ["value_maps", field], message });
    }
});
/** Parses `config/mappings/<file>.yaml`; issues name the document `mappings/<file>`. */
function parseMappingDocument(file, input) {
    return (0, config_issue_js_1.parseConfigDocument)(exports.mappingDocumentSchema, `mappings/${file}`, input);
}
//# sourceMappingURL=mapping.js.map